<div class="box">
    <div class="boxsec">
        <div class="iconsec">
            <img src="{{path}}" alt="" />
        </div>
        <div class="textsec">
            <h3>{{messageh3}}</h3>
            <p>{{messagep}}</p>
            <a (click)="hidepopup()">{{close}}</a>
        </div>
    </div>
</div>